<template>
<div class="page">
    <div class="page__bd" style="background-color: #f1f1f1;">
        <div v-for="(contract, index) in listInfo" :class="[{'gap': index != 0}, 'weui-form-preview']"
            @click.stop.prevent="detail(contract.id, contract.orderId, contract.taskId, contract.taskName)">
            <div class="weui-form-preview__hd">
                <div class="weui-form-preview__item">
                    <label class="weui-form-preview__label">文件名称</label>
                    <em class="weui-form-preview__value">{{contract.title}}</em>
                </div>
            </div>
            <div class="weui-form-preview__bd">
                <div class="weui-form-preview__item">
                    <label class="weui-form-preview__label">类别</label>
                    <span class="weui-form-preview__value">{{contract.contractActionLabel}}</span>
                </div>
                <div class="weui-form-preview__item">
                    <label class="weui-form-preview__label">性质</label>
                    <span class="weui-form-preview__value">{{contract.typeLabel}}</span>
                </div>
                <div class="weui-form-preview__item">
                    <label class="weui-form-preview__label">创建时间</label>
                    <span class="weui-form-preview__value">{{contract.createTime}}</span>
                </div>
                <div class="weui-form-preview__item">
                    <label class="weui-form-preview__label">状态</label>
                    <span class="weui-form-preview__value">{{getContractState(contract)}}</span>
                </div>
            </div>
            <div class="weui-form-preview__ft">
                <a @click.stop.prevent="detail(contract.id, contract.orderId, contract.taskId, contract.taskName)" class="weui-form-preview__btn weui-form-preview__btn_primary">查看</a>
            </div>
        </div>
    </div>
</div>
</template>
<script>
  import { mapActions } from 'vuex'
  export default {
    props: ['btnname', 'listInfo', 'viewType'],
    data () {
      return {
        hellow: '123'
      }
    },
    methods: {
      ...mapActions([
        'resetContractDetail'
      ]),
      detail (contractId, orderId, taskId, taskName) {
        let queryData = {
          orderId: orderId,
          selected: this.$route.query.selected,
          showNavbar: this.$route.query.showNavbar
        }

        if (taskId && taskId.length > 0) {
          queryData['taskId'] = taskId
        }

        if (taskName && taskName.length > 0) {
          queryData['taskName'] = taskName
        }

        this.$router.push({
          path: '/contract/' + this.viewType + '/' + contractId,
          query: queryData
        })
      },
      getContractState (contract) {
        if (contract.state === 10) {
          return '合同已废除'
        } else if (contract.state === 50) {
          return '已删除'
        } else if (contract.displayName) {
          return contract.displayName
        } else if (contract.state === 100) {
          return '待提交申请'
        } else if (contract.state === 900) {
          return '已归档'
        }
        return ''
      }
    },
    mounted: function () {
      // 进入list页，将contract的详情记录重置为空
      this.resetContractDetail()
    }
  }
</script>
<style>
  .gap{
    margin-top: 5px
  }
</style>



// WEBPACK FOOTER //
// list.vue?37254308